import { PriceApi } from "@/api/PricesApi";

export async function prefetchPriceSilently() {
    PriceApi.fetchAll()
}